import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import routes from "./routes";
import Layout from "./components/Layout/Layout";
import { CheckDevice, ScrollTop, ScrollBottom } from "./utils/CommonFunctions";

import useScreenSize from "./hooks/useScreenSize";

import "./App.css";
import { Alert, Confirm } from "./components/Modal/MsgBox";
import { CookiesProvider } from "react-cookie";
import { ModalProvider } from "./components/Modal/ModalProvider";

function App() {
  CheckDevice();

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // get title index in routes
  const pathParts = pathname.split("/");
  const modifiedPathname2 = pathParts.slice(0, 3).join("/");
  const currentIndex = routes.findIndex((item) =>
    item.path.includes(modifiedPathname2),
  );

  // get '404 Page not found' index in routes
  const errorPage = routes
    .map((e) => {
      return e.path;
    })
    .indexOf("*");

  // Document Head Title update
  const newTitle = `${
    currentIndex !== -1 ? routes[currentIndex].title : routes[errorPage].title
  } | 기술사업화지원센터`;
  document.title = newTitle;
  document
    .querySelector('meta[property="og:title"]')
    .setAttribute("content", newTitle);

  const screenSize = useScreenSize();

  return (
    <div className="App">
      <CookiesProvider>
        <ModalProvider>
          <Routes>
            <Route element={<Layout />}>
              {routes.map((route) => (
                <Route
                  key={route.id}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Route>
          </Routes>

          <Alert id="d-alert" />
          <Confirm id="d-confirm" />
        </ModalProvider>
      </CookiesProvider>

      {screenSize.width <= 1440 ? (
        <>
          <ScrollTop />
          <ScrollBottom />
        </>
      ) : null}
    </div>
  );
}

export default App;
